import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import {Link} from "react-router-dom";
import {ILiteArticle} from "../Home/Blog";


export interface Props {
  title: string,
  articles: ILiteArticle[]
}

const Blog = (props: Props) => {


  return (

    <section>
      <div className={"blog-part"} style={{marginTop: "2px", background: "#f8f8f8", borderRadius: "8px", lineHeight: "24px", padding: '0',maxWidth:"calc(100% - 32px)",margin:"8px auto 16px auto"}}>
        <div className={"header"} style={{paddingRight: "8px", marginTop: "0", background: "transparent", width: "calc(100% - 32px)", paddingTop: "0",height:"40px"}}>
          {props.title}
        </div>
      </div>


      <Swiper
        slidesPerView={2.2}
        spaceBetween={8}
        style={{paddingRight: "20px", paddingLeft: "20px"}}
        freeMode={true}
        grabCursor={true}
        onSwiper={(swiper: any) => {
        }}
      >
        {
          props.articles.map((row, index) => {
            return <SwiperSlide key={index}>
              <Link to={"/blog/" + row.id} className={"blog-row"}>
                <picture>
                  <source srcSet={row.image}/>
                  <img src={row.image} width={"100%"} alt="" style={{borderRadius: "8px"}}/>
                </picture>
                <h2>{row.title}</h2>
                <div className={"article-date"}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                       style={{width: 12, verticalAlign: "middle", paddingLeft: 4}} fill={"#666"}>
                    <path
                      d="M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"/>
                  </svg>
                  {row.date}
                </div>
              </Link>
            </SwiperSlide>
          })
        }


      </Swiper>


    </section>
  );
};

export default Blog;